import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as promoService from "../../services/promo.services";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDateWithMonth, removeSpecialCharacter } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { Placeholder} from "rsuite";



const ViewPromo = (props) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("Promotion Management"),
      url: "/admin/promotion-management/list/1",
    },
    { title: t("btn_view"), url: "" },
  ];


  useEffect(() => {
    promoService
      .Details(params?._id)
      .then((response) => {
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);


 const writtenFunction = (skill_preferences) => {

  const formattedSkills = skill_preferences.map((skill) => {
    return skill
      .split('_')  
      .map((word) => (word)) 
      .join(' '); 
  });
  return capitalizeFirstLetter(formattedSkills.join(', ')); 
};


  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">
                  View Promotion Details
                </h6>
              </div>
              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                        <tr>
                          <th>{t("Name")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.name
                              ? capitalizeFirstLetter(showdefault?.name)
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th className="text-capitalize">{t("Code")}</th>
                          <td>
                            {showdefault && showdefault?.code
                              ? (showdefault?.code)
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("Discount")}(%)</th>
                          <td>
                            {showdefault && showdefault?.discountValue
                              ? (showdefault?.discountValue)
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>Type</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.type
                              ? capitalizeFirstLetter(showdefault?.type)
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Expire Date")}</th>
                          <td>
                            {showdefault && showdefault.expiresAt
                              ? formateDateWithMonth(showdefault.expiresAt)
                              : "N/A"}
                          </td>
                        </tr> 
                        <tr>
                          <th>{t("Created Date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? formateDateWithMonth(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>                    
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
               <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              )}
            </div>


            <div className="mt-5 back-button">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() =>
                  navigate("/admin/promotion-management/list/1")
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewPromo;
